const translations = {
    en: {
        // Homepage translations
        homepageTitle: "Industrial Giudecca",
        blurbElmBlurbSubTitle: "\"A history without memory.\"",
        blurbElmScrollText: "This platform tells the story of industry on Giudecca.",
        deeperDive: "Let's take a deeper dive",
        intoIndustrialHistory: "into the industrial history of Giudecca ...",
        travelToIndustrialSitesButton: "Continue to learn more about the industrial sites of Giudecca",

        // Timeline on homepage translations
        activeLabel: "industrial site",
        activeLabelPlural: "industrial sites",
        mapWas: "was",
        mapIs: "is",
        mapWere: "were",
        onGiudecca: "on Giudecca",
        clickToLearnMore: "Click on a pin to learn more",
        skipTimeline: "Skip Timeline",
        resetTimeline: "Reset Timeline",
        keepScrolling: "Scroll to advance timeline",

        // Search bar 
        searchForIndustrialSites: "Search for industrial sites...",
        showFactoriesWithStories: "Show factories with stories",
        showAllFactories: "Show all factories",

        // Sidebar translations
        sideBarHome: "Home",
        sideBarIndustrial: "Industrial Sites",
        sideBarDataExplorer: "Data Explorer",
        sideBarHistoricalStories: "Industrial Stories",
        sideBarInteractiveMap: "Interactive Map",
        sideBarAbout: "About",

        // Titles 
        dataExplorerTitle: "Data Explorer",             // Data Explorer 
        industrialStoriesTitle: "Industrial Stories",   // Industrial Stories 
        aboutTitle: "About",                            // About
        factoryHomepageTitle: "Industrial Sites",       // Factory Homepage (industrial sites page)
        scrollToLearnMore: "Scroll to Learn More",      // Scroll to learn more message at bottom

        // Data Explorer Page & Components 
        noResultsFound: "No results found.",
        factoryNameEnglish: "Factory Name (English)",
        factoryNameItalian: "Factory Name (Italian)",
        product: "Product",
        maxEmployment: "Max Employment",
        minEmployment: "Min Employment",
        maxYear: "Max Year",
        minYear: "Min Year",
        selectCurrentPurpose: "Select Current Purpose", 
        selectProduct: "Select a Product",
        search: "Search",

        // BasicFactoryTemplate FactoryTimeline
        startsProducing: "Primary product/industry:",
        has: "has",
        employees: "employees",
        closes: "closes",
        opens: "opens",
        goToHome: "Go to Home",
        goToIndustrialSites: "Go to Industrial Sites",
        goToStories: "Go to Stories Page",

        // About page translations
        projectOverview: "Project Overview",
        briefDescription: "Digitizing historical data is a process that has been made possible through advancements in modern technology." +
            " Digital databases allow researchers and historians to access copious amounts of information and data; moreover, the digitization of data provides easier access to a wider range of audiences. " +
            "For this project, we seized an opportunity to digitize data about social, cultural, and economic history." +
            " We created a digital database and designed a digital platform to provide users with information about Giudecca’s industrial history." +
            " It is our hope that this project inspires future work to explore solutions for preserving delicate, culturally significant histories.",

        disclaimer: "Disclaimer: While the website was created in collaboration with Dr. Lando, and sourced from his book, the book was translated by Google Translate and was interpreted by the Industrial Giudecca Team. Any inaccuracies in data came from the Industrial Giudecca Team and not Dr. Pietro Lando. Any Italian translations were done by DeepL and were not heavily proofread.\n",


        landoSection1: "Born in Lido di Venezia, where he has always lived, he graduated in Biological Sciences, in\n" +
            "                            Padua in 1978, and in History, in Venice in 2001.\n" +
            "                            Historian of industrial Venice at the turn of the 20th century, he published:",
        landoSection2: "\n" +
            "                            2013 Le ali di Venezia (fifty years of twentieth-century Venetian history as seen through the vicissitudes of aviation) for the publisher Il Poligrafo of Padua,\n" +
            "\n" +
            "                            2023 the volume Giudecca dedicated to the history of the island in the 20th century, for the publisher Il Poligrafo of Padua,\n" +
            "\n" +
            "                            2018 I primi tumultuosi anni del Lido di Venezia da Fisola a Spada (dedicated to the origin of the tourism in Venice Lido), for the publisher El Squero of Venice, and\n" +
            "\n" +
            "                            2024  Ferro, Carbone e Vapore. L’antimito di Venezia industriale 1880-1917 (concerning the origins of the industrial revolution in Venice) in, edited by L. Zan, Storia, sviluppo e sostenibilità. Venezia un caso particolare, for the publisher Il Mulino of Bologna.\n" +
            "\n" +
            "                        ",
        landoSection3: "He collaborates with the universities of Venice and Bologna in connection with his\n" +
            "researches on Venice at the turn of the 19th and 20th centuries.",

        serenDPTSection1: "This project would not have been possible without the work and support of Fabio Carerra and SerenDPT.\n" +
            "                            Professor Carerra, the Director at WPI’s Venice Project Center and Founder of SerenDPT,\n" +
            "                            worked with us and the other teams throughout our experience to provide feedback and guidance on our projects.\n" +
            "                            We are extremely grateful for his support.",

        serenDPTSection2: "In addition to Professor Carerra, the SerenDPT staff, including Gianluca, Aurora, and Marco, were incredibly helpful throughout this journey.\n" +
            "                            They worked with us to accurately translate the site’s content into Italian and made sure we had a positive, memorable experience in Venice.",

        industrialGiudeccaTitle: "The Industrial Giudecca Team",
        industrialGiudeccaSection1: "The Industrial Giudecca Team, composed of four students with diverse backgrounds: Tim is majoring in management engineering; Mary is pursuing a double major\n" +
            "                            in biomedical engineering and mechanical engineering; Justin and Parker are computer science majors; together, we worked with\n" +
            "                            Dr. Lando, our advisors Rick Vaz and Chrys Demetry, SerenDPT staff, and a variety of\n" +
            "                            Venetian organizations to aggregate data and tell the lost history of industry on Giudecca.",

        industrialGiudeccaSection2: "We cannot over-explain the impact of our project advisors Rick Vaz and Chrys Demetry. Throughout the semester, they guided, encouraged, and supported us in our goals; their feedback and\n" +
            "                            support for our work were paramount to our success.\n" +
            "                            We are incredibly grateful for the time and effort they put in to help us grow as students and teammates.",

        industrialGiudeccaSection3: "We would like to give a special thank you to our sponsor, Dr. Pietro Lando, for providing his book Giudecca and for sharing his passion for preserving a place with such a rich history. In addition to his passion, his knowledge and expertise was fundamental to our data collection and in telling the history of industry on Giudecca.\n" +
            "\n" +
            "                            Dr. Lando went above and beyond acting as a normal sponsor; he helped us enjoy our time in Venice outside the project by recommending places to see, eat, and experience in and around the lagoon. He elevated our time here by sharing his knowledge of the area beyond Giudecca's industrial history.",

        buttonBottomAbout: "Click to learn more about our process and journey",


    },
    it: {
        // Homepage translations
        homepageTitle: "Giudecca Industriale",
        blurbElmBlurbSubTitle: "\"Una storia senza memoria\"",
        blurbElmScrollText: "Questa piattaforma racconta la storia dell'industria alla Giudecca.",
        deeperDive: "Facciamo un'immersione più profonda",
        intoIndustrialHistory: "nella storia industriale della Giudecca ...",
        travelToIndustrialSitesButton: "Continua a conoscere i siti industriali della Giudecca",

        // Timeline on homepage translations
        activeLabel: "sito industriale",
        activeLabelPlural: "siti industriali",
        mapWas: "c'era",
        mapIs: "c'è",
        mapWere: "c'erano",
        onGiudecca: "sulla Giudecca",
        keepScrolling: "Scorri per avanzare nella sequenza temporale",
        clickToLearnMore: "Fare Clic su uno Spillo per Saperne di Più",
        skipTimeline: "Salta la Sequenza Temporale",
        resetTimeline: "Reimpostare la Sequenza Temporale",

        // Search bar 
        searchForIndustrialSites: "Ricerca di siti industriali...",
        showFactoriesWithStories: "Mostrare le fabbriche con storie",
        showAllFactories: "Mostra tutte le fabbriche",

        // Sidebar translations
        sideBarHome: "Casa",
        sideBarIndustrial: "Siti industriali",
        sideBarDataExplorer: "Esploratore dati",
        sideBarHistoricalStories: "Storie industriali",
        sideBarInteractiveMap: "Mappa interattiva",
        sideBarAbout: "Circa",

        // Titles 
        dataExplorerTitle: "Esploratore Dati",          // Data Explorer 
        industrialStoriesTitle: "Storie Industriali",   // Industrial Stories 
        aboutTitle: "Circa",                            // About
        factoryHomepageTitle: "Siti Industriali",       // Factory Homepage (industrial sites page)
        scrollToLearnMore: "Scorri per saperne di più", // Scroll to learn more message at bottom

        // Data Explorer Page & Components
        noResultsFound: "Nessun Risultato Trovato.",
        factoryNameEnglish: "Nome della Fabbrica (Inglese)",
        factoryNameItalian: "Nome della fabbrica (Italiano)",
        product: "Prodotto",
        maxEmployment: "Occupazione Massima",
        minEmployment: "Occupazione Minima",
        maxYear: "Anno Massimo",
        minYear: "Anno Minimo",
        selectCurrentPurpose: "Seleziona lo Scopo Attuale",
        selectProduct: "Seleziona il Prodotto",
        search: "Ricera",

        // BasicFactoryTemplate FactoryTimeline
        startsProducing: "Prodotto primario/industria:",
        has: "ha", 
        employees: "dipendenti",
        closes: "Chiude",
        opens: "Apre",
        goToHome: "Vai a Casa",
        goToIndustrialSites: "Recarsi nei Siti Industriali",
        goToStories: "Vai alla Pagina delle Storie",

        // About page translations
        projectOverview: "Panoramica del progetto",
        briefDescription: "La digitalizzazione dei dati storici è un processo reso possibile dai progressi della tecnologia moderna. I database digitali consentono a ricercatori e storici di accedere a una grande quantità di informazioni e dati; inoltre, la digitalizzazione dei dati facilita l'accesso a un pubblico più ampio. Per questo progetto, abbiamo colto l'opportunità di digitalizzare i dati sulla storia sociale, culturale ed economica, creando un database e progettando una piattaforma digitale per fornire agli utenti informazioni sulla storia industriale della Giudecca. Ci auguriamo che questo progetto ispiri un lavoro futuro per esplorare soluzioni per preservare storie delicate e culturalmente significative.\n",
        disclaimer: "Disclaimer: Sebbene il sito sia stato creato in collaborazione con il Dr. Pietro Lando e tratto dal suo libro, quest'ultimo è stato tradotto da Google Translate ed è stato interpretato dal Team della Giudecca Industriale. Eventuali imprecisioni nei dati provengono dall'Industrial Giudecca Team e non dal Dr. Pietro Lando. Le traduzioni in Italiano sono state effettuate da DeepL e non sono state sottoposte a un'accurata revisione.\n",
        landoSection1: "Nato al Lido di Venezia, dove ha sempre vissuto, si è laureato in Scienze Biologiche a Padova nel 1978 e in Storia a Venezia nel 2001. \n" +
            "Storico della Venezia industriale a cavallo del 20th secolo, ha pubblicato: ",
        landoSection2: "2013 il volume Le ali di Venezia (cinquant'anni di storia veneziana del Novecento visti attraverso le vicende dell'aviazione) per l'editore Il Poligrafo di Padova\n" +
            "\n" +
            "2023 il volume Giudecca dedicato alla storia dell'isola nel XX secolo, per l'editore Il Poligrafo di Padova\n" +
            "\n" +
            "2108 il volume I primi tumultuosi anni del Lido di Venezia da Fisola a Spada (dedicato alle origini del turismo al Lido di Venezia), per l'editore El Squero di Venezia.\n" +
            "\n" +
            "2024 il saggio Ferro, Carbone e Vapore. L'antimito di Venezia industriale 1880-1917 (sulle origini della rivoluzione industriale a Venezia) in, a cura di L. Zan, Storia, sviluppo e sostenibilità. Venezia un caso particolare, per l'editore Il Mulino di Bologna. \n",
        landoSection3: "Collabora con le Università di Venezia e Bologna per le sue ricerche su Venezia a cavallo tra Ottocento e Novecento.\n",

        serenDPTSection1: "Questo progetto non sarebbe stato possibile senza il lavoro e il sostegno di Fabio Carerra e della SerenDPT. Il professor Carerra, direttore del Venice Project Center della WPI e fondatore della SerenDPT, ha lavorato con noi e con gli altri team durante tutta la nostra esperienza per fornire feedback e indicazioni sui nostri progetti. Gli siamo estremamente grati per il suo sostegno.",
        serenDPTSection2: "Oltre al professor Carerra, il personale della SerenDPT, tra cui Gianluca, Aurora e Marco, è stato incredibilmente disponibile durante tutto il viaggio. Hanno lavorato con noi per tradurre accuratamente i contenuti del sito in italiano e si sono assicurati che la nostra esperienza a Venezia fosse positiva e memorabile.",

        industrialGiudeccaTitle: "Il team di Industrial Giudecca",
        industrialGiudeccaSection1: "Il team della Giudecca industriale, composto da quattro studenti con background diversi: Tim si sta specializzando in ingegneria gestionale; Mary sta conseguendo una doppia laurea in ingegneria biomedica e meccanica; Justin e Parker sono laureati in informatica; insieme, abbiamo lavorato con il dottor Lando, i nostri consulenti Rick Vaz e Chrys Demetry, lo staff del SerenDPT e una serie di organizzazioni veneziane per aggregare dati e raccontare la storia perduta dell'industria alla Giudecca.\n",
        industrialGiudeccaSection2: "L'impatto dei nostri consulenti per il progetto, Rick Vaz e Chrys Demetry, non può essere spiegato a sufficienza. Per tutto il semestre ci hanno guidati, incoraggiati e sostenuti nei nostri obiettivi; il loro feedback e il loro sostegno al nostro lavoro sono stati fondamentali per il nostro successo. Siamo incredibilmente grati per il tempo e l'impegno che hanno dedicato ad aiutarci a crescere come studenti e compagni di squadra.\n",
        industrialGiudeccaSection3: "Desideriamo ringraziare in modo particolare il nostro sponsor, il dottor Pietro Lando, per averci messo a disposizione il suo libro Giudecca e per aver condiviso la sua passione per la conservazione di un luogo così ricco di storia. Oltre alla sua passione, le sue conoscenze e competenze sono state fondamentali per la raccolta dei dati e per raccontare la storia dell'industria della Giudecca. Il dottor Lando è andato oltre il ruolo di normale sponsor; ci ha aiutato a goderci il nostro tempo a Venezia al di fuori del progetto, consigliandoci luoghi da vedere, mangiare e sperimentare nella laguna e nei dintorni. Ha arricchito il nostro tempo qui condividendo la sua conoscenza dell'area al di là della storia industriale della Giudecca.\n",


        buttonBottomAbout: "Clicca per saperne di più sul nostro processo e sul nostro viaggio\n",
    }
};

export default translations;